import { IGeoMappingItem } from '../models/geoMappingItem'
import { IMappedGeoMappingItem } from '../models/mappedGeoMappingItem'

export const mapGeoMappingItem = (geoMapping: IGeoMappingItem): IMappedGeoMappingItem => {
  return {
    itemId: geoMapping.Id,
    parentId: geoMapping.ParentId,
    name: geoMapping.Name,
    shortName: geoMapping.ShortName,
    countries: geoMapping.Countries.split(','),
    order: geoMapping.GeoMarketOrder,
    geoMarket: geoMapping.GeoMarketsNew || geoMapping.GeoMarkets,
  }
}
